import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { API } from 'utils';

import { cache } from '../cache';
import { errorLink } from '../links/errorLink';

const { createUploadLink } = require("apollo-upload-client");

const httpLink = createUploadLink({
	uri: `${API.NOTIFICATIONClient.url}`,
});

const notificationClientLink = errorLink().concat(httpLink);

export const notificationClient = new ApolloClient<NormalizedCacheObject>({
	link: notificationClientLink,
	cache,
	queryDeduplication: false,
	connectToDevTools: true,
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'cache-and-network',
		},
		query: {
			fetchPolicy: 'network-only',
		},
	},
});

export default notificationClient;
